import { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Home from "./pages/Home";
import YujaLumina from "./pages/YujaLumina";
import InterviewerExperience from "./pages/InterviewerExperience";
import Press from "./pages/Press";
import NotFound from "./pages/NotFound";
import CustomCursor from "./components/CustomCursor";
import Preloader from "./components/Preloader";
import SmoothScroll from "./components/SmoothScroll";
import { ThemeProvider } from "./components/ThemeProvider";
import { Toaster } from "sonner";

const AnimatedRoutes = () => {
  const location = useLocation();
  useEffect(() => {
    // Lenis hijacks native scroll — reset via its API when present, then fall back.
    if (window.__lenis) {
      window.__lenis.scrollTo(0, { immediate: true, force: true });
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/work/yuja-lumina" element={<YujaLumina />} />
        <Route path="/work/interviewer-experience" element={<InterviewerExperience />} />
        <Route path="/press" element={<Press />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AnimatePresence>
  );
};

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 2400);
    return () => clearTimeout(t);
  }, []);

  return (
    <ThemeProvider>
      <div className="App grain" data-testid="app-root">
        <CustomCursor />
        <SmoothScroll>
          <AnimatePresence>{loading && <Preloader key="preloader" />}</AnimatePresence>
          <BrowserRouter>
            <AnimatedRoutes />
          </BrowserRouter>
        </SmoothScroll>
        <Toaster position="bottom-right" theme="dark" richColors />
      </div>
    </ThemeProvider>
  );
}

export default App;
